<template>
  <div style="width: 100%; height: 100%;">
    <iframe :src="href" frameborder="0" width="100%" :height="height"></iframe>
  </div>
</template>
<script>
  import clonedeep from 'lodash.clonedeep'
  export default {
    data () {
      return {
        href: '',
        height: String(0.9 * window.screen.availHeight)
      }
    },
    created () {
      if (this.params.inputs) {
        this.href = clonedeep(this.params.inputs)
      }
    },
    props: ['params']
  }
</script>



// WEBPACK FOOTER //
// src/components/byl/iframeBox/index.vue